import domUtil, { SingletonRequestAnimationFrame } from '~/utils/domUtil';
import { useLayoutEffect, useRef } from 'react';

const useSingletonRequestAnimationFrame = <T extends (...args: any[]) => any>(
  callback: T
): ReturnType<SingletonRequestAnimationFrame<Parameters<T>>> => {
  const fnRef = useRef<ReturnType<SingletonRequestAnimationFrame<Parameters<T>>>>(
    domUtil.singletonRequestAnimationFrame(callback)
  );

  useLayoutEffect(() => {
    fnRef.current?.dispose();
    fnRef.current = domUtil.singletonRequestAnimationFrame(callback);
    return () => fnRef.current?.dispose();
  }, [callback]);
  return fnRef.current;
};

export default useSingletonRequestAnimationFrame;
